var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tabs-trigger",class:{'active': _vm.active == _vm.name},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.handleClick(_vm.name)}}},[_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721d0016","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Tabs/Trigger.vue
// module id = jT2N
// module chunks = 115 116